import { ROUTES } from '@/routes/paths';
import type { BestPriceEntry, PriceListGroup } from '@/types/buy';

/** Ссылка на деталь группы прайс-листа (/app/buy/group) — единая точка сборки query. */
export function makeGroupUrl(group: PriceListGroup): string {
  const qs = new URLSearchParams({
    address: group.address,
    addressTitle: group.addressTitle,
    goods: group.goods,
    year: String(group.year),
  });
  return `${ROUTES.APP_BUY_GROUP}?${qs.toString()}`;
}

export interface OfferLinkContext {
  /** Оффер продажи (из лучшей цены). */
  readonly entry: BestPriceEntry;
  /** Моя строка закупки, под которую покупаем (нет при входе с экрана поиска «Лучшая цена»). */
  readonly fromPurchaseOrderId?: number;
  /** Мой базис (точка выгрузки) — адрес доставки сделки. */
  readonly toAddress: string;
  readonly toAddressTitle: string;
  /** Родительский товар (для ГОСТ-дефолтов приёмки) и год (для ссылки «назад» в группу). */
  readonly goods: string;
  readonly year?: number;
  /** Выгода относительно моей цены, ₽/т (со знаком) — для показа «к вашей цене» на превью; нет в поиске. */
  readonly advantage?: number;
}

/** Ссылка на превью оффера продажи (/app/buy/offer) со всем контекстом покупки в query. */
export function makeOfferUrl(context: OfferLinkContext): string {
  const qs = new URLSearchParams({
    saleOrderId: String(context.entry.saleOrderId),
    saleOrderVersion: String(context.entry.saleOrderVersion),
    toAddress: context.toAddress,
    toAddressTitle: context.toAddressTitle,
    goods: context.goods,
  });
  if (context.fromPurchaseOrderId != null) {
    qs.set('fromPurchaseOrderId', String(context.fromPurchaseOrderId));
  }
  if (context.year != null) {
    qs.set('year', String(context.year));
  }
  if (context.advantage != null) {
    qs.set('advantage', String(context.advantage));
  }
  return `${ROUTES.APP_BUY_OFFER}?${qs.toString()}`;
}
